import PropTypes from 'prop-types';

import './styles/index.css';

const SkeletonBox = ({ width, height, isCircle }) => (
  <span
    className={`skeleton-box ${!isCircle ? 'skeleton-box__rad2' : 'skeleton-box__rad50'}`}
    style={{ width, height }}
  />
);

SkeletonBox.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isCircle: PropTypes.bool
};

SkeletonBox.defaultProps = {
  width: '100%',
  height: 200,
  isCircle: false
};

export default SkeletonBox;
